import AppUtils from "./apputlis";
import axios from 'axios';
import AesUtils from "../network/AesUtils";

console.disableYellowBox = true // 关闭全部黄色警告 
console.log('process.env.REACT_APP_ENV', process.env.REACT_APP_ENV);
if (process.env.REACT_APP_ENV == 'production') {
    console.log = function () { }
}

export default class AppConfig {

    static domains = [
        "https://jk.djxppls.cn/",
        "https://jk.bhnavap.cn/",
        "https://jk.kscafwr.cn/",
        "https://jk.cfamxgz.cn/",
        "https://beijing.scklmqe.cn/",
        "https://hongkong.hwgfyfo.cn/",
        "https://jk.bbqiu.vip/",
    ];

    static deviceid = AppUtils.getUniqueID();
    static channelid = 3;
    static version = 101;
    static hostApi = AppConfig.getUrl();
    static lauchUrl = 'https://app.huria.live/';
    static isAndroid = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1; //android终端
    static isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    static APP_NAME = '播球帝';
    static isInitHostApi = false;
    static errDomainIndex = 0;
    static TXDOMAINCFG = "https://launch-1305013790.cos.ap-nanjing.myqcloud.com/domain.config";
    static ALDOMAINCFG = "https://iososs1.oss-cn-hongkong.aliyuncs.com/domain.config";

    static endWith(s, r) {
        var d = s.length - r.length;
        return (d >= 0 && s.lastIndexOf(r) == d);
    }

    static checkDomains() {
        AppConfig.checkHttp(AppConfig.domains, true);
    }

    static checkHttp(domains, con) {
        for (let i = 0; i < domains.length; i++) {
            AppConfig.pingDomain(domains[i], domains.length, con);
        }
    }

    static pingDomain(url, len, con) {
        if (url[url.length - 1] != '/') {
            url = url + '/';
        }
        let u = url + 'app/encryptionVersion';
        axios.get(u).then(response => {
            try {
                if (response && response.code == 200) {
                    if (!AppConfig.isInitHostApi) {
                        AppUtils.setStorageItem('DOMAIN_LIST', url);
                        AppConfig.hostApi = url;
                        AppConfig.isInitHostApi = true;
                        console.log('hostApi===>', url);
                    }
                } else {
                    let result = AesUtils.decrypt(response.data);
                    result = JSON.parse(result);
                    if (result.code == 200) {
                        if (!AppConfig.isInitHostApi) {
                            AppUtils.setStorageItem('DOMAIN_LIST', url);
                            AppConfig.hostApi = url;
                            AppConfig.isInitHostApi = true;
                            console.log('hostApi===>', url);
                        }
                    } else {
                        AppConfig.errDomainIndex++;
                        if (len == AppConfig.errDomainIndex && con) {
                            AppConfig.getTxDomains();
                        }
                    }
                }

            } catch (error) {
                AppConfig.errDomainIndex++;
                if (len == AppConfig.errDomainIndex && con) {
                    AppConfig.getTxDomains();
                }
            }
        }).catch(err => {
            AppConfig.errDomainIndex++;
            if (len == AppConfig.errDomainIndex && con) {
                AppConfig.getTxDomains();
            }
        })
    }

    static getUrl() {
        let url = AppUtils.getStorageItem('DOMAIN_LIST');
        if (url == null || url == undefined || url == '') {
            url = AppConfig.domains[Math.floor(Math.random() * AppConfig.domains.length)];
        }
        if (url[url.length - 1] != '/') {
            url = url + '/';
        }
        console.log('getUrl===>', url);
        AppConfig.checkDomains();
        return url;
    }

    static getTxDomains() {
        AppConfig.getDomains(AppConfig.TXDOMAINCFG)
    }

    static getAlDomains() {
        AppConfig.getDomains(AppConfig.ALDOMAINCFG)
    }

    static getDomains(u) {
        let to = u == AppConfig.TXDOMAINCFG;
        axios.get(u).then(response => {
            try {
                let d = response['com.bqd.livetv'];
                AppConfig.errDomainIndex = 0;
                AppConfig.checkHttp(d, to);
            } catch (error) {
                if (to) {
                    AppConfig.getAlDomains();
                }
            }
        }).catch(err => {
            if (to) {
                AppConfig.getAlDomains();
            }
        })
    }
}